import React, {
  useCallback,
  useDeferredValue,
  useEffect,
  useState,
} from "react";
import { Helmet } from "react-helmet";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Spin, Table, Typography } from "antd";
import { useAppMessage } from "../../../hooks/useAppMessage";
import TableEmptyContent from "../../../Components/TableEmptyContent/TableEmptyContent";
import { STATUS_MANAGEMENT_COLUMNS_HEAD } from "./StatusManagementUtils";
import AdminHeaderTab from "../../../Components/headerTab/AdminHeaderTab";
import { StatusManagementAPI } from "../../../API/admin/StatusManagementAPI";
import { AddNewStatus } from "./AddNewStatus";
import EditStatus from "./EditStatus";
const { Text } = Typography;

function StatusManagement() {
  const [messageApi, contextHolder] = useAppMessage();
  const [spinning, setSpinning] = useState(false);
  const [addEmployeeModal, setAddEmployeeModal] = useState(false);
  const [statusList, setStatusList] = useState([]);
  const [serachVal, setSearchVal] = useState("");
  const [defualtData, setDefualtData] = useState([]);
  const [editEmployeeModal, setEditEmployeeModal] = useState(false);
  const [editData, setEditData] = useState({
    id: "",
    name: "",
  });

  const serachFun = useCallback(() => {
    let arr = [...defualtData];
    const filterArr = arr.filter((ele) => {
      return (
        !serachVal.trim() ||
        String(`${ele.name}`)
          .toLowerCase()
          .includes(serachVal.trim().toLowerCase())
      );
    });
    setStatusList(filterArr);
  }, [defualtData, serachVal]);

  const deferredQuery = useDeferredValue(serachVal);
  useEffect(() => {
    serachFun();
  }, [deferredQuery, serachFun]);

  const messageToast = useCallback(
    (type, message) => {
      messageApi.open({
        type: type,
        content: message,
        duration: 6,
      });
    },
    [messageApi],
  );

  const loadConfigData = useCallback(async () => {
    setSpinning(true);
    await StatusManagementAPI.getTableList()
      .then((res) => {
        if (res.data.status === true) {
          const arr = res.data?.statuses.map((ele, index) => ({
            ...ele,
            serial_no: index + 1,
          }));
          setDefualtData(arr);
          setStatusList(arr);
        } else {
          messageToast("error", res.data?.message);
        }
      })
      .catch(() => messageToast("error", "Internal Server Error"))
      .finally(() => setSpinning(false));
  }, [messageToast]);

  async function confirmDelete(ele) {
    setSpinning(true);
    await StatusManagementAPI.deleteStatus(ele?.id)
      .then((res) => {
        if (res.data.status === true) {
          messageToast("success", res.data?.message);
          loadConfigData();
        } else {
          messageToast("error", res.data?.message);
        }
      })
      .catch(() => messageToast("error", "Internal Server Error"))
      .finally(() => setSpinning(false));
  }

  function editStatusFun(ele) {
    setEditData({
      id: ele?.id,
      name: ele?.name,
    });
    setEditEmployeeModal(true);
  }

  useEffect(() => {
    loadConfigData();
  }, [loadConfigData]);

  return (
    <div className="container_div">
      <Helmet>
        <title>SpecOptimizer | Admin</title>
      </Helmet>

      <AdminHeaderTab currrentTab="Status Management" />

      <div className="admin_tab_content_wraper">
        <Spin spinning={spinning}>
          <div className="table_head_wraper">
            <Text className="table_head">Status Management</Text>
            <div className="table_custom_buttons">
              <div
                style={{
                  borderRadius: "25px",
                  backgroundColor: "#EBEEF8",
                  color: "#737373",
                  display: "flex",
                  marginRight: "10px",
                  flex: "1 1 0px ",
                }}
              >
                <input
                  value={serachVal}
                  onChange={(e) => setSearchVal(e.target.value)}
                  className="searc_input"
                />
                <SearchOutlined
                  className="search_btn"
                  style={{
                    color: !serachVal ? "#737373" : "#ff4d4f",
                    fontSize: "18px",
                    padding: "10px",
                    borderRadius: "6px",
                  }}
                />
              </div>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => setAddEmployeeModal(true)}
              >
                Add New
              </Button>
            </div>
          </div>

          <div>
            <Table
              rowKey="serial_no"
              columns={STATUS_MANAGEMENT_COLUMNS_HEAD(
                confirmDelete,
                editStatusFun,
              )}
              dataSource={statusList}
              pagination={{
                pageSize: 10,
                responsive: true,
                hideOnSinglePage: true,
              }}
              style={{ marginTop: "20px" }}
              className="antdTable"
              locale={{
                emptyText: <TableEmptyContent />,
              }}
            />
          </div>
        </Spin>
      </div>

      <AddNewStatus
        open={addEmployeeModal}
        setOpen={setAddEmployeeModal}
        messageToast={messageToast}
        loadConfigData={loadConfigData}
      />
      <EditStatus
        open={editEmployeeModal}
        setOpen={setEditEmployeeModal}
        messageToast={messageToast}
        loadConfigData={loadConfigData}
        editData={editData}
      />
      {contextHolder}
    </div>
  );
}

export default StatusManagement;
